import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentsService } from 'app/shared/services/documents/documents.service';
import { Subject, takeUntil } from 'rxjs';
import { IQuestionnaires } from 'app/interfaces';
import { HomeService } from '../../services/home.service';

import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [SharedModule, FormsModule],
})
export class DocumentUploadComponent implements OnInit, OnDestroy {
  questionnaireInstanceId: number | null = null;
  assessmentId: number | null = null;
  questionnaire: IQuestionnaires | undefined = undefined;
  uploadProgres: any;
  isError: boolean = false;
  @ViewChild('uploadBtn', { static: true }) uploadBtn: ElementRef | null = null;
  private documentsService: DocumentsService = inject(DocumentsService);
  private router: Router = inject(Router);
  private homeService: HomeService = inject(HomeService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.isError = false;
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe({
      next: (val) => {
        this.questionnaireInstanceId = Number(val['questionnaireInstanceId']);
        this.assessmentId = Number(val['assessmentId']);
      },
    });

    this.questionnaire = undefined;
    this.homeService.activeCampaign.pipe(takeUntil(this.destroy$)).subscribe({
      next: (campaign) => {
        if (campaign === 'flu') {
          this.homeService.fluQuestionnaires.pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
              this.setQuestionnaire(data);
            },
          });
        } else {
          this.homeService.covidQuestionnaires.pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
              this.setQuestionnaire(data);
            },
          });
        }
      },
    });
  }

  setQuestionnaire(campaignData: IQuestionnaires[]) {
    if (campaignData) {
      this.questionnaire = campaignData.find((el) => {
        return el.assessmentId == this.assessmentId ? el : null;
      });
    }
  }

  uploadFile(event: Event) {
    const input = event.target as HTMLInputElement;
    this.isError = false;
    if (!input.files?.length) {
      return;
    }
    const file = input.files[0];
    if (
      file &&
      file.size &&
      file.size / 1024 / 1024 < 10 &&
      file.type &&
      file.type.match(/image\/jpeg|image\/jpg|image\/png|application\/pdf/)
    ) {
      this.documentsService.uploadFile(file, this.questionnaireInstanceId);
      this.documentsService.progress.pipe(takeUntil(this.destroy$)).subscribe({
        next: (resp) => {
          if (resp && resp.uploadProgress) {
            this.uploadProgres = resp.uploadProgress;
          }
          if (this.uploadBtn) {
            this.uploadBtn.nativeElement.value = '';
          }
        },
      });
    } else {
      if (this.uploadBtn) {
        this.uploadBtn.nativeElement.value = '';
      }
      this.isError = true;
      /*this.eventService.showMessage({
        severity: 'warn',
        summary: 'File type or size is wrong.',
        detail: 'Document must be in a JPG, JPEG, PNG, or PDF format and cannot exceed 10MB.'
      });*/
    }
  }

  goHome() {
    this.router.navigate(['home'], { replaceUrl: true });
  }
}
